export default __webpack_public_path__ + "static/media/requesticon.1c6cf746.svg";